import axios from 'axios';

export default {
  namespaced: true,
  state: {
    importReports: [],
    importReportsTotal: 0,
    importReportsLoading: false,
    importReportsError: null,
    contactsReports: [],
    contactsReportsTotal: 0,
    contactsReportsLoading: false,
    contactsReportsError: null,
    reimportFileURL: '',
    reimportFileURLLoading: false,
    reimportFileURLError: null,
  },
  getters: {
    hasImportContactsLeftToFetch(state) {
      return state.importReports.length < state.importReportsTotal;
    },
  },
  mutations: {
    // Mutations for importReports
    setImportReports(state, reports) {
      const data = reports.data || [];
      state.importReports = data;
      state.importReportsTotal = reports.total;
    },
    appendImportReports(state, reports) {
      const data = reports.data || [];
      state.importReports = [...state.importReports, ...data];
      state.importReportsTotal = reports.total;
    },
    setImportReportsLoading(state, loading) {
      state.importReportsLoading = loading;
    },
    setImportReportsError(state, error) {
      state.importReportsError = error;
    },
    clearImportReports(state) {
      state.importReports = [];
      state.importReportsTotal = 0;
    },

    // Mutations for contactsReports
    setContactsReports(state, contactsReports) {
      state.contactsReports = contactsReports;
    },
    setContactsReportsTotal(state, total) {
      state.contactsReportsTotal = total;
    },
    setContactsReportsLoading(state, loading) {
      state.contactsReportsLoading = loading;
    },
    setContactsReportsError(state, error) {
      state.contactsReportsError = error;
    },
    setReimportFileURL(state, fileURL) {
      state.reimportFileURL = fileURL;
    },
    setReimportFileURLoading(state, loading) {
      state.reimportFileURLLoading = loading;
    },
    setReimportFileURLError(state, error) {
      state.reimportFileURLError = error;
    },
  },
  actions: {
    async findImportReports({ commit }, querySettings) {
      commit('setImportReportsLoading', true);

      const { page } = querySettings.pagination;
      const shouldResetTable = page === 1;
      if (shouldResetTable) {
        commit('clearImportReports');
      }
      const limit = 10;
      const skip = limit * (page - 1);
      let params = {
        $skip: skip,
        $limit: limit,
      };

      const { archived } = querySettings;
      if (archived) {
        params['archived'] = archived;
      }

      try {
        const { data } = await axios.get(
          `${process.env.VUE_APP_CONTACTS_MS_BASE_URL}/import/reports`,
          {
            params,
          },
        );
        if (shouldResetTable) {
          commit('setImportReports', data);
        } else {
          commit('appendImportReports', data);
        }
      } catch (error) {
        if (error && error.data && error.data.error) {
          commit('setImportReportsError', error.data.error);
        } else {
          commit('setImportReportsError', error);
        }
      }

      commit('setImportReportsLoading', false);
    },
    async findContactsReports({ commit }, querySettings) {
      commit('setContactsReportsLoading', true);

      const { status, page, limit, masterID } = querySettings;

      const skip = limit * (page - 1);
      let params = {
        $skip: skip,
        $limit: limit,
        status: status,
        '$sort[id]': 1,
      };

      try {
        const {
          data: { data, total },
        } = await axios.get(
          `${process.env.VUE_APP_CONTACTS_MS_BASE_URL}/import/reports/${masterID}/records`,
          {
            params,
          },
        );
        commit('setContactsReports', data);
        commit('setContactsReportsTotal', total);
      } catch (error) {
        if (error && error.data && error.data.error) {
          commit('setContactsReportsError', error.data.error);
        } else {
          commit('setContactsReportsError', error);
        }
      }

      commit('setContactsReportsLoading', false);
    },
    async getReimportFileURL({ commit }, { masterID }) {
      commit('setReimportFileURLoading', true);

      try {
        const {
          data: { url },
        } = await axios.get(
          `${process.env.VUE_APP_CONTACTS_MS_BASE_URL}/import/${masterID}/reimport`,
        );
        commit('setReimportFileURL', url);
      } catch (error) {
        if (error && error.data && error.data.error) {
          commit('setReimportFileURLError', error.data.error);
        } else {
          commit('setReimportFileURLError', error);
        }
      }
      commit('setReimportFileURLoading', false);
    },
  },
};
